import damageReportDecorators from './DamageReport/dataProviderDecorators'

export const decorateDataProvider = decorators => dp => decorators.reduce((dp, d) => d(dp), dp)

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  ...damageReportDecorators,
]